var _excluded = ["component", "error", "success", "className", "children"];

var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import { styled } from '@creditas-ui/system';
import { Box } from '@creditas-ui/layout';
import { ifProp, selectTheme } from '@creditas-ui/utilities';
var DropdownHelperTextElement = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e3wyblz0"
} : {
  target: "e3wyblz0",
  label: "DropdownHelperTextElement"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: normal;\n  display: block;\n  padding: ", ";\n  font-family: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), selectTheme('dropdown.helperText.padding'), selectTheme('dropdown.helperText.fontFamily'), selectTheme('dropdown.helperText.lineHeight'), selectTheme('dropdown.helperText.letterSpacing'), selectTheme('dropdown.helperText.fontSize'), ifProp('error', selectTheme('dropdown.helperText.error.color'), ifProp('success', selectTheme('dropdown.helperText.success.color'), selectTheme('dropdown.helperText.color'))));

var DropdownHelperText = _ref => {
  var {
    component = 'span',
    error,
    success,
    className,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(DropdownHelperTextElement, _extends({}, props, {
    as: component,
    className: className,
    error: error,
    success: success
  }), children);
};

export { DropdownHelperText };
//# sourceMappingURL=DropdownHelperText.js.map